import React from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import Button from "@material-ui/core/Button";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListSubheader from "@material-ui/core/ListSubheader";
import LogoAprendro from "../images/logoaprendo.png";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  list: {
    width: 250,
  },
  fullList: {
    width: "auto",
  },
  laminas: {
    fontFamily: "Gotham Rounded",
    fontWeight: 100,
    fontSize: 20,
    color: "#ccc",
  },
  laminas1: {
    fontFamily: "Gotham Rounded",
    fontWeight: 600,
    fontSize: 16,
    color: theme.palette.primary.main,
  },
  laminas2: {
    fontFamily: "Gotham Rounded",
    fontWeight: 600,
    fontSize: 16,
    color: theme.palette.blue.main,
  },
  laminas3: {
    fontFamily: "Gotham Rounded",
    fontWeight: 600,
    fontSize: 16,
    color: theme.palette.green.main,
  },
  laminas4: {
    fontFamily: "Gotham Rounded",
    fontWeight: 600,
    fontSize: 16,
    color: theme.palette.purple.main,
  },
  aprendo: {
    padding: "1em",
    "& img": {
      maxWidth: "100%",
    },
  },
}));

const TemporaryDrawer = ({ history }) => {
  const classes = useStyles();
  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const redirectPage = (page) => {
    history.push(page);
  };

  const list = (anchor) => (
    <div
      className={clsx(classes.list, {
        [classes.fullList]: anchor === "top" || anchor === "bottom",
      })}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <div className={classes.aprendo}>
        <img src={LogoAprendro} alt="Aprendo en casa" />
      </div>
      <List
        subheader={
          <ListSubheader component="div" id="nested-list-subheader">
            Láminas
          </ListSubheader>
        }
      >
        <ListItem button>
          <ListItemText
            primary="Convivimos y nos cuidamos en nuestros espacios de ciudadanía"
            classes={{ primary: classes.laminas1 }}
            onClick={() => redirectPage("/lamina-1-1")}
          />
        </ListItem>
        <ListItem button>
          <ListItemText
            primary="Respetamos nuestros derechos y deberes para el bien de todos"
            classes={{ primary: classes.laminas2 }}
            onClick={() => redirectPage("/lamina-1-12")}
          />
        </ListItem>
        <ListItem button>
          <ListItemText
            primary="Vivimos la diversidad con justicia y equidad"
            classes={{ primary: classes.laminas3 }}
            onClick={() => redirectPage("/lamina-1-18")}
          />
        </ListItem>
        <ListItem button>
          <ListItemText
            primary="Conocemos la organización de nuestro Estado"
            classes={{ primary: classes.laminas4 }}
            onClick={() => redirectPage("/lamina-1-24")}
          />
        </ListItem>
      </List>
      <Divider />
      <List>
        <ListItem button onClick={() => redirectPage("/")}>
          <ListItemText primary="Sobre Ciudadanía Activa" />
        </ListItem>
      </List>
    </div>
  );

  return (
    <div>
      <React.Fragment>
        <Button onClick={toggleDrawer("right", true)}>
          <i className="fas fa-bars"></i>
        </Button>
        <Drawer
          anchor={"right"}
          open={state["right"]}
          onClose={toggleDrawer("right", false)}
        >
          {list("right")}
        </Drawer>
      </React.Fragment>
    </div>
  );
};

TemporaryDrawer.propTypes = {
  history: PropTypes.object,
};

export default withRouter(TemporaryDrawer);
